import React from 'react';
import {Dialog, DialogContent} from "@mui/material";
import CuttingImageGallery from "./CuttingImageGallery";

const ModalImageGallery = ({
                               open,
                               images,
                               weight,
                               height,
                               setOpenModalImageGallery,
                               currentPage,
                               setCurrentPage,
                               vectorMode = false,
                               vectorCuttingMap = null,
                               vectorPageCount = 0,
                               drawEdge = true,
                           }) => {
    return (
        <div>
            <Dialog open={open} fullScreen={true} fullWidth={true} maxWidth='lg'>
                <DialogContent>
                    <CuttingImageGallery
                        images={images}
                        isLoading={false}
                        setOpenModalImageGallery={setOpenModalImageGallery}
                        weight={weight}
                        height={height}
                        buttonClose={true}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        vectorMode={vectorMode}
                        vectorCuttingMap={vectorCuttingMap}
                        vectorPageCount={vectorPageCount}
                        drawEdge={drawEdge}
                    />
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default ModalImageGallery;
